// extracted by mini-css-extract-plugin
export default {"spotlightContainer":"spotlight_spotlightContainer__FeA14","spotUl":"spotlight_spotUl__EiKgj","wardropeUl":"spotlight_wardropeUl__7rHvJ"};